import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import logo from "../assets/images/home/logo.png";
import product from "../assets/images/cart/product-2.jpg";
import { varifyUser } from "../Functions/UserLogin";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import Offcanvas from "react-bootstrap/Offcanvas";



import axios from "axios";
import { Email } from "@mui/icons-material";
import { useEmail } from "./VerifyEmail";
import { RxCross2 } from "react-icons/rx";
import MobileHeader from "./MobileHeader";
import { useFilter } from "./VerifyEmail";
import PriceRangeModal from "./PriceRangeModal";

const Header = (data) => {
  const { EmailVerify, userData, setUserData } = useEmail();
  const {
    searchText,
    handleKeyDown,
    setSearchText,
    handleSearchClick,
    handleInputChange,
    priceRangeName,
    setPriceRangeName
  } = useFilter();
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!location.pathname.startsWith('/product-list')) {
      setSearchText("");
      setPriceRangeName("All Price");
    }
  }, [location.pathname]);

  const [show, setShow] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [CategoryData, setCategoryData] = useState([]);
  const fetchData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/auth/list/CategoryMaster`
    );
    setCategoryData(res.data);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const [token, setToken] = useState("");
  const [Name, setName] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "Alphabet",
      details: "Safaribags S2",
      quantity: 1,
      imgSrc: "../assets/images/cart/product-1.jpg",
    },
    {
      id: 2,
      name: "Rugby Ball",
      details: "Safaribags S11",
      quantity: 2,
      imgSrc: "../assets/images/cart/product-2.jpg",
    },
  ]);
  const [selectedOption, setSelectedOption] = useState("");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleRemoveItem = async (productId) => {
    try {
      const userId = localStorage.getItem("user");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/remove/user-cart-item`,
        {
          userId,
          productId,
        }
      );

      if (response.data.success) {
        const updatedCart = userData.cart.filter(
          (item) => item.productName._id !== productId
        );
        setUserData((prev) => ({ ...prev, cart: updatedCart }));
      }
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  const cartTotalQuantity = cartItems.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const Email = localStorage.getItem("user");
  useEffect(() => {
    EmailVerify();
  }, [Email]);
  const [totalQuantity, setTotalQuantity] = useState("");

  useEffect(() => {
    if (userData && userData.cart) {
      const total = userData.cart.reduce((acc, item) => acc + item.quantity, 0);
      setTotalQuantity(total);
    }
  }, [userData]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    toast.success("Account Logged out Successfully");

    EmailVerify();
  };
  const [priceRanges, setPriceRanges] = useState([]);

  useEffect(() => {
    const fetchPriceRanges = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/PriceRangeMaster`);
        setPriceRanges(res.data || []);
      } catch (error) {
        console.error("Error fetching price ranges:", error);
      }
    };
    fetchPriceRanges();
  }, []);


  const splitPriceRanges = (ranges, numColumns) => {
    const columns = [];
    const itemsPerColumn = Math.ceil(ranges.length / numColumns);
    for (let i = 0; i < ranges.length; i += itemsPerColumn) {
      columns.push(ranges.slice(i, i + itemsPerColumn));
    }
    return columns;
  };

  const priceColumns = splitPriceRanges(priceRanges, 2);

  const handlePriceSelect = (price) => {
    setPriceRangeName(price.label);
    const maxPrice = price.endPrice;
    navigate(`/product-list?maxPrice=${maxPrice}&minPrice=${price.startPrice}&rangeName=${encodeURIComponent(price.label)}`);
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-left">
            <p className="welcome-msg">Welcome to Chanakya Corporate</p>
          </div>
          <div className="header-right">
            {userData && userData.Email ? (
              <>
                {/* ================= DESKTOP ACCOUNT ================= */}
                {!isMobile && (
                  <Dropdown>
                    <Dropdown.Toggle className="dropdownHader welcome-msg">
                      Welcome, {userData.Name}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdownHaderMenu">
                      <Dropdown.Item as={Link} to="/myAccount">
                        My Account
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleLogout}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}

                {/* ================= MOBILE ACCOUNT ================= */}
                {isMobile && (
                  <button
                    className="account-toggle"
                    onClick={() => setShow(true)}
                  >
                    <i className="w-icon-account"></i>
                  </button>
                )}
              </>
            ) : (
              <>
                {/* 👇 THIS WAS MISSING */}
                <div className="d-none d-md-flex">
                  <Link to="/Login" className="login sign-in">
                    <i className="w-icon-account"></i> Sign In
                  </Link>
                  <span className="delimiter">/</span>
                  <Link to="/SignUp" className="login register">
                    Register
                  </Link>
                </div>

                <div className="d-md-none">
                  <button
                    className="account-toggle"
                    onClick={() => setShow(true)}
                  >
                    <i className="w-icon-account"></i>
                  </button>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
      <div className="header-middle border-no">
        <div className="container">
          <div className="header-left mr-md-4">
            <MobileHeader />
            <Link to="/" className="logo">
              <img src={logo} alt="logo" />
            </Link>
            <form
              method="get"
              action="#"
              className="input-wrapper header-search hs-expanded hs-round d-none d-md-flex"
            >
              <div className="select-box bg-white">
                <button
                  className="priceDropdown"
                  type="button"
                  onClick={() => setShowPriceModal(true)}
                >
                  {priceRangeName}
                </button>
              </div>
              <input
                type="text"
                className="form-control bg-white pt-0 pb-0"
                name="search"
                id="search"
                value={searchText}
                onChange={(e) => {
                  handleInputChange(e.target.value);
                }}
                onKeyDown={handleKeyDown}
                placeholder="What are you looking for..."
              />
              <button
                className="btn btn-search"
                type="button"
                onClick={handleSearchClick}
              >
                <i className="w-icon-search"></i>
              </button>
            </form>
          </div>
          <div className="header-right ml-4">
            <div className="header-call d-xs-show d-md-flex align-items-center">
              <Link to="tel:#" className="w-icon-call"></Link>
              <div className="call-info d-md-show">
                <h4 className="chat font-size-md text-normal ls-normal text-white mb-0">
                  <Link
                    to="mailto:info@chanakya.com"
                    className="text-capitalize  font-weight-normal"
                    style={{ color: "#a01e20" }}
                  >
                    Live Chat
                  </Link>
                  <span className="text-light orTitle font-weight-normal">
                    or :
                  </span>
                </h4>
                <a
                  href="tel:+919974017725"
                  className="phone-number font-weight-bolder ls-50"
                >
                  9974017725
                </a>
                <a
                  href="tel:+919974017727"
                  className="phone-number font-weight-bolder ls-50"
                >
                  {" "}||   9974017727
                </a>
              </div>
            </div>

            <div
              className={`dropdown cart-dropdown cart-offcanvas mr-0 mr-lg-2 ${isOpen ? "opened" : ""
                }`}
            >
              <div
                className={`cart-overlay ${isOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              ></div>
              <a
                className="cart-toggle label-down link"
                onClick={toggleDropdown}
              >
                <i className="w-icon-cart">
                  <span className="cart-count text-white">
                    {userData && userData.cart ? userData.cart.length : "0"}
                  </span>
                </i>
                <span className="cart-label">Cart</span>
              </a>
              {isOpen && (
                <div className="dropdown-box opened">
                  <div className="cart-header">
                    <span>Shopping Cart</span>
                    <a href="#" onClick={toggleDropdown}>

                      <IoMdClose style={{ fontSize: "15px" }} className="w-icon-long-arrow-right" />
                    </a>
                  </div>
                  <div className="products">
                    {userData && userData.cart.length > 0 ? (
                      userData.cart.map(
                        (item, index) =>
                          item.productName && (
                            <div
                              className="product product-cart"
                              key={item._id}
                            >
                              <div className="product-detail">
                                <p className="text-start product-name mb-0">
                                  {item.productName.productName}
                                </p>

                                <div className="price-box">
                                  <span className="product-quantity">
                                    {item.quantity}
                                  </span>
                                  <span className="product-price">QTY</span>
                                </div>
                              </div>
                              <figure className="product-media">
                                <a href="#">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/${item.productName.productImage}`}
                                    alt={item.productName.productName}
                                    width="84"
                                    height="94"
                                  />
                                </a>
                              </figure>
                              <button
                                className="btn btn-link btn-close"
                                onClick={() =>
                                  handleRemoveItem(item.productName._id)
                                }
                              >
                                <RxCross2 className=" m-0 cross" />
                              </button>
                            </div>
                          )
                      )
                    ) : (
                      <div>
                        <Link
                          to="/product-list"
                          onClick={toggleDropdown}
                          className="btn btn-primary btn-rounded"
                        >
                          Explore our products
                        </Link>
                      </div>
                    )}
                  </div>

                  {userData && userData.cart.length !== 0 && (
                    <div>
                      <div className="cart-total">
                        <label>Subtotal:</label>
                        <span className="price">{totalQuantity} QTY</span>
                      </div>
                      <div className="cart-action">
                        <Link
                          to="/cart"
                          onClick={toggleDropdown}
                          className="btn btn-dark btn-outline btn-rounded"
                        >
                          View Cart
                        </Link>
                        <Link
                          to="checkout"
                          onClick={toggleDropdown}
                          className="btn btn-primary btn-rounded"
                        >
                          Checkout
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      <PriceRangeModal
        show={showPriceModal}
        onHide={() => setShowPriceModal(false)}
        priceRanges={priceRanges}
        onSelectPrice={handlePriceSelect}
      />
      {/* ================= MOBILE ACCOUNT OFFCANVAS ================= */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Account</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {userData && userData.Email ? (
            <>
              {/* Logged-in user */}
              <p className="fw-bold mb-3 text-center">
                Welcome, {userData.Name}
              </p>

              <Link
                to="/myAccount"
                className="btn btn-outline-primary w-100 mb-3"
                onClick={() => setShow(false)}
              >
                My Account
              </Link>

              <button
                className="btn btn-danger w-100"
                onClick={() => {
                  handleLogout();
                  setShow(false);
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              {/* Guest user */}
              <Link
                to="/Login"
                className="btn btn-outline-primary w-100 mb-3"
                onClick={() => setShow(false)}
              >
                Sign In
              </Link>

              <Link
                to="/SignUp"
                className="btn btn-primary w-100"
                onClick={() => setShow(false)}
              >
                Register
              </Link>
            </>
          )}
        </Offcanvas.Body>

      </Offcanvas>

    </header>
  );
};

export default Header;
